export const getAll = state => state.ageRanges.data
export const getById = (state, ageRangeId) => state.ageRanges.data.find(ageRange => ageRange.id === ageRangeId)